// http://yapi.umu.work/project/696/interface/api/12869
import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IListResponse, IPKListItem } from '@umu/umu-types';

enum SortType {
    STUDENT = 1,
    TEACHER = 2,
}

interface IInput {course_id: string; activity_id?: string;sort_type?: SortType;}
// 获取课程PK团队信息
export const getPKList = (input: IInput): Promise<IListResponse<IPKListItem>> => {
    const param = {
        ...input,
        sort_type: input.sort_type || SortType.STUDENT,
    };
    return fetchData(API.GET_COURSE_PK_LIST, param);
};
